export const passwordMinLength = 8;

export const hasUpperCase = (value: string) : boolean => {
    return !!value.match(/([A-Z])+/g);
}

export const hasLowerCase = (value: string) : boolean => {
    return !!value.match(/([a-z])+/g);
}

export const hasSpecialCharacter = (value: string) : boolean => {
    return !!value.match(/([(\-()/{}:;,.?!@#$%&+=*)])+/g);
}

export const hasNumber = (value: string) : boolean => {
    return !!value.match(/([0-9])+/g);
}

export const hasWhitespace = (value: string) : boolean => {
    return !!value.match(/\s+/g);
}

export const hasMinLength = (value: string, minLength?: number) : boolean => {
    if(minLength) return value?.length >= minLength;
    else return true;
}